import { render, staticRenderFns } from "./MortgagesDocuments.vue?vue&type=template&id=d8bb8284&"
import script from "./MortgagesDocuments.vue?vue&type=script&lang=ts&"
export * from "./MortgagesDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports